// extracted by mini-css-extract-plugin
export default {"TableFooter":"T6w1Po8zkWdq1YQeoS1hxQ==","PaginationBlock":"i1M7m925uN385mEE1TuBMA==","PaginationIconSet":"vwT5GOg6fygvG4htYNIrNA=="};